import { createPortal } from "react-dom";
import { WarningI, WarningIDark } from "../../assets";
import useAlertStore from "../../store/useAlertStore";
import { useTheme } from "../../context/ThemeProvider";
import ConfirmDialog from "../shared/ConfirmDialog/ConfirmDialog";

const SpectraDeletedModal = () => {
  const theme = useTheme();
  const isOpen = useAlertStore((state) => state.isOpen);
  const setIsOpen = useAlertStore((state) => state.setIsOpen);
  const title = useAlertStore((state) => state.title);
  const headline = useAlertStore((state) => state.headline);
  const callback = useAlertStore((state) => state.callback);

  const handleClose = () => {
    setIsOpen(false);
    callback?.();
  };

  if (!isOpen) return null;

  return createPortal(
    <ConfirmDialog
      open={isOpen}
      title={title}
      icon={theme === "dark" ? <WarningIDark /> : <WarningI />}
      confirmLabel="Ok"
      confirmVariant="danger"
      showCancel={false}
      divider
      onCancel={handleClose}
      onConfirm={handleClose}
    >
      {headline}
    </ConfirmDialog>,
    document.body
  );
};

export default SpectraDeletedModal;
